module.exports = __webpack_public_path__ + "images/dingtalk/init-todolist-5be1b3a27cfa5af637865ad18666a41b.png";